import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import Modal from "../../../../../components/Modal";
import Button from "../../../../../components/Button";

function SyncTimesheetModal({ isOpen, close, values }) {
    const { t } = useTranslation();

    const { onSuccess, field } = values || {};
    const confirm = useCallback(() => {
        onSuccess?.();
        close();
    }, [onSuccess, close])

    return (
        <Modal
            isOpen={isOpen}
            centered
        >
            <h3 className="p-4">
                {t("sync-the-{{field}}-of-the-adjacent-timesheet", { field: field })}
            </h3>

            <div className="d-flex gap-2">
                <Button type="button" color="secondary" className="w-100" onClick={close}>
                    {t("only-update-original")}
                </Button>
                <Button type="button" color="primary" className="w-100" onClick={confirm}>
                    {t("sync")}
                </Button>
            </div>
        </Modal>
    );
}

export default SyncTimesheetModal;
